import { IApplicationState } from '../../types/redux';

export function getOffices(state: IApplicationState) {
  return state.developer.offices;
}
